import { ReactElement, Fragment } from 'react';

type Props = { text: string };

export const TextField = (props: Props): ReactElement => <Fragment>{props.text}</Fragment>;
